import { HomeHeroSection } from "@/components/ui/Screens/Homepage/HomeHeroSection";
import { HomeUtilities } from "./HomeUtilities";
import { HomeContact } from "./HomeContact";
import { HomeFleets } from "./HomeFleets";
import { HomeEachService, ServicesIntroduction } from "./HomeServices";
import { HomeIntro } from "./HomeIntro";
import { MainFooter } from "../../Footer/MainFooter";
import styled from "styled-components";
import { Grid } from "antd";
import { ComponentHomepageSnap } from "./HomepageSnap";

const { useBreakpoint } = Grid;

export const SERVICES_STEP = {
	FIRST: "FIRST",
	SECOND: "SECOND",
	THIRD: "THIRD",
};
export function ComponentHomePageWrapper({ pageContent = {} }) {
	const { content = {} } = pageContent;
	const { xl } = useBreakpoint();

	return (
		<>
			{pageContent && (
				<>
					{xl ? (
						<ComponentHomepageSnap pageContent={pageContent} />
					) : (
						<>
							<HomeHeroSection banner={content?.banner} />
							<BodyContainer>
								<HomeUtilities why_fly_private={content?.why_fly_private} />
							</BodyContainer>
							<HomeFleetsBodyContainer>
								<BodyContainer>
									<HomeFleets step_aboard_our_fleet={content?.step_aboard_our_fleet} />
								</BodyContainer>
							</HomeFleetsBodyContainer>
							<div style={{ paddingTop: 64 }}>
								<ServicesIntroduction
									explore_our_innovative_solutions={content?.explore_our_innovative_solutions}
								/>
							</div>
							<WrapperService>
								<BodyContainer>
									<HomeEachService
										explore_our_innovative_solutions={content?.explore_our_innovative_solutions}
										step={SERVICES_STEP.FIRST}
									/>
								</BodyContainer>
								<BodyContainer>
									<HomeEachService
										explore_our_innovative_solutions={content?.explore_our_innovative_solutions}
										step={SERVICES_STEP.SECOND}
									/>
								</BodyContainer>
								<BodyContainer>
									<HomeEachService
										explore_our_innovative_solutions={content?.explore_our_innovative_solutions}
										step={SERVICES_STEP.THIRD}
									/>
								</BodyContainer>
							</WrapperService>

							<HomeIntro video={content?.video} />
							<BodyContactUs>
								<HomeContact connect_with_us={content?.connect_with_us} />
							</BodyContactUs>
							<footer
								style={{
									width: "100%",
									scrollSnapAlign: "end",
								}}
							>
								<MainFooter />
							</footer>
						</>
					)}
				</>
			)}
		</>
	);
}

const HomeFleetsBodyContainer = styled.div`
	background-image: url("/images/private-jet-travel/private-jet-travel-mask.svg");
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	scroll-snap-align: start;
	width: 100%;
	max-width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;

	@media (max-width: 1199px) {
		padding-block: 120px;
	}

	@media (max-width: 991px) {
		padding-block: 80px;
	}

	@media (max-width: 767px) {
		padding-block: 64px;
	}

	@media (max-width: 575px) {
		padding-block: 32px;
	}
`;
const BodyContainer = styled.div`
	max-width: 1442px;
	padding: 0 136px;
	width: 100%;
	&.home-utilities-container-outer {
		margin-top: 50px;
	}
	@media (max-width: 991px) {
		padding: 0 80px;
	}
	@media (max-width: 767px) {
		padding: 0 32px;
	}
	@media (max-width: 575px) {
		padding: 0 20px;
	}
`;
const BodyContactUs = styled.div`
	max-width: 1442px;
	width: 100%;
	padding: 100px 136px;
	&.home-utilities-container-outer {
		margin-top: 50px;
	}
	@media (max-width: 991px) {
		padding: 80px 80px;
	}
	@media (max-width: 767px) {
		padding: 60px 32px;
	}
	@media (max-width: 575px) {
		padding: 40px 20px;
	}
`;
const WrapperService = styled.div`
	@media (max-width: 575px) {
		padding: 30px 0;
	}
`;
